import { Button, CopyButton } from '@repletoryreach/sdk-ui';
import { useT } from '../../../../i18n/I18nProvider';

/**
 * A value somebody has to paste somewhere else (the business's address into a
 * mailbox's forwarding rule, a DNS record into their DNS host's editor), shown
 * whole with a Copy button beside it.
 */
export function CopyValue({ value, label }: { value: string; label?: string }) {
  const t = useT();
  return (
    <span className="rr-email__copy">
      <code className="rr-email__value">{value}</code>
      <CopyButton value={value}>
        {({ copied, failed, copy }) => (
          <Button size="xs" variant="subtle" onClick={copy} aria-label={label ? t('settings.email.copyLabel', { what: label }) : undefined}>
            {failed ? t('common.copyFailed') : copied ? t('settings.email.copied') : t('action.copy')}
          </Button>
        )}
      </CopyButton>
    </span>
  );
}
